import script from "./Observer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Observer.vue?vue&type=script&lang=ts&setup=true"

import "./Observer.vue?vue&type=style&index=0&id=7b570737&lang=scss"

const __exports__ = script;

export default __exports__